import React from 'react'
import Card from '../../../common/card/Card'
import ProgressCard from '../../../common/card/ProgressCard'
import { useGroupDashboardContext } from '../GroupDashboardContext'

const TeamSeats = ({ 
  teamData = [],
  teamOptionsData = {},
}) => {

  const { filtersData } = useGroupDashboardContext()

  return (
    <Card title={`${filtersData.woo.teams.singular_label} Seats`}>
      <div className="msync-card__body msync-org-stats">
        { teamData.team_type === 'wooteams' && <>
          <ProgressCard 
              content={{
                  'title': 'Plan',
                  'value': teamData.team_membership_plan_name ?? 'N/A'
              }}
          />
          <ProgressCard 
              content={{
                  'title': 'Seats',
                  'value': teamData.team_seat_count ?? 'Unlimited'
              }}
          />
        </> }
        <ProgressCard 
            content={{
                'title': 'Members',
                'value': teamData.team_members_count ?? 'N/A'
            }}
        />
        <ProgressCard 
            content={{
                'title': 'Created On',
                'value': teamData.team_created_on ? new Date(teamData.team_created_on).toDateString() : 'N/A'
            }}
        />
      </div>
    </Card>
  )
}

export default TeamSeats
